import axios from "axios";

const CMS_BASE_URL = `${process.env.REACT_APP_CMS_BASEURL}`;


// const LUNG_CARE_API_URL = `${process.env.REACT_APP_LUNGSCARE}`;

export function getVisionMainData() {


  return axios.get(`${CMS_BASE_URL}vision-cares?populate=first,third,third.thirdsub,fourth,fourth.fourthsub,fifth,fifth.fifthsub,sixth,sixth.sixthsub`, 
  );
 
 
}

// Single-request alternative to paginating get_report_list — read-only lookup of
// one vision care submission by its request_id (ORDERID in the get_report_list row).
// STATUS: 0 queued, 3 backend accepted/processing, 1 done, 2 failed. 404 until the row exists.
export function getVisioncareStatus(requestId, patientid) {
  const url = new URL(`visioncare-status/${requestId}`, process.env.REACT_APP_QUANTUMURL).toString();
  return axios.get(url, { params: { patientid } });
}
